import React, {Component} from "react"

import authentication from "@irati/auth"
import {H3} from "@irati/ui/src//Typography/Heading"
import {FormattedMessage, FormattedCurrency, injectIntl, InjectIntl} from "@irati/utils/lang"
import {Para} from "@irati/ui/src/Labels"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import TenantWalletTransferType from "@irati/wallet/enums/TenantWalletTransferType"
import {User} from "@irati/types"

import {StyledModal, TopCard, GreyCard, InnerCard, BalanceRow, StyledButton} from "./styled"
import ModalHeader from "./ModalHeader"
import RewardWalletRow from "./RewardWalletRow"

interface Props extends InjectIntl {
  handleClose: () => void,
  handleRepeatAgain: () => void,
  show: boolean,
  amount: number,
  transferType: TenantWalletTransferType,
  totalAmount: number,
  currency: string,
  recipients: User[],
  tenantId: string,
  remainingAmount: number
}

class TransferCreditConfirmationPopup extends Component<Props> {
  static defaultProps = {
    pending: false
  }

  render() {
    const tenantName = authentication.userTenant().public_name
    const {
      handleClose,
      handleRepeatAgain,
      show,
      recipients,
      totalAmount,
      remainingAmount,
      amount,
      currency,
      transferType
    } = this.props

    return (
      <StyledModal
        show={show}
        useMobileStyling={false}
        onHide={handleClose}
        onExited={handleClose}
        renderHeader={() => <ModalHeader />}>
        <TopCard>
          <H3 small>
            <FormattedMessage id="wallet.tenant.transferConfirmation.success" />
          </H3>
          <Para center large>
            <FormattedMessage
              values={{
                credit: formatCurrency({
                  currencyCode: currency,
                  value: totalAmount,
                  isCents: false
                }),
                tenantName
              }}
              id={transferType === TenantWalletTransferType.TRANSFER
                ? "wallet.tenant.transferConfirmation.creditTransferred"
                : "wallet.tenant.transferConfirmation.refundTransferred"} />
          </Para>
        </TopCard>
        <GreyCard>
          <InnerCard>
            {recipients.map((recipient, i) =>
              <RewardWalletRow
                transferType={transferType}
                recipient={recipient}
                isFirst={i === 0}
                amount={amount} />
            )}
            <BalanceRow>
              <Para bold>
                <FormattedMessage
                  values={{tenantName}}
                  id={transferType === TenantWalletTransferType.TRANSFER
                    ? "wallet.tenant.transferConfirmation.remainingBalance"
                    : "wallet.tenant.transferConfirmation.updatedBalance"} />
              </Para>
              <Para bold>
                <FormattedCurrency
                  isCents={false}
                  currency={currency}
                  value={remainingAmount} />
              </Para>
            </BalanceRow>
            <StyledButton primary onClick={handleRepeatAgain}>
              <FormattedMessage
                id={transferType === TenantWalletTransferType.TRANSFER
                  ? "wallet.tenant.transferConfirmation.transferAgain"
                  : "wallet.tenant.transferConfirmation.refundAgain"} />
            </StyledButton>
          </InnerCard>
        </GreyCard>
      </StyledModal>
    )
  }
}

export default injectIntl(TransferCreditConfirmationPopup)
